export default __webpack_public_path__ + "static/media/portalcfdi.d9c832d4.svg";